// components/PropertyCard.js
import React from 'react';
import { Link } from 'react-router-dom';
import './PropertyCard.css';

// Iconos SVG
const BedIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M7 14c1.66 0 3-1.34 3-3S8.66 8 7 8s-3 1.34-3 3 1.34 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm12-3h-8v8H3V7H1v10h22v-6c0-2.21-1.79-4-4-4zm2 8h-8V9h6c1.1 0 2 .9 2 2v4z"/>
  </svg>
);

const BathIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M21 10V7c0-1.65-1.35-3-3-3H6C4.35 4 3 5.35 3 7v3c-1.65 0-3 1.35-3 3v5c0 1.65 1.35 3 3 3h18c1.65 0 3-1.35 3-3v-5c0-1.65-1.35-3-3-3zM5 7c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v3.78c-1.16-.41-2.47-.78-3.78-.78-2.38 0-4.52.94-6.22 2.42V7zm17 11c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1v-5c0-.55.45-1 1-1s1 .45 1 1v4h16v-4c0-.55.45-1 1-1s1 .45 1 1v5z"/>
  </svg>
);

const AreaIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M3 3v18h18V3H3zm16 16H5V5h14v14zM7 7h10v2H7zm0 4h10v2H7zm0 4h7v2H7z"/>
  </svg>
);

const PropertyCard = ({ property }) => {
  return (
    <div className="property-card">
      <div className="property-image">
        <img src={property.image} alt={property.title} />
        <div className="property-type">{property.type}</div>
      </div>
      <div className="property-info">
        <h3>{property.title}</h3>
        <p className="location">{property.location}</p>
        <p className="price-home">{property.price}</p>
        {property.alquiler && <p className="rent-home"> Alq:  {property.alquiler} x Mes</p>}
        <div className="property-features">
          <div className="feature-item">
            <div className="feature-icon">
              <BedIcon />
            </div>
            <span className="feature-text">{property.bedrooms} hab.</span>
          </div>
          
          <div className="feature-item">
            <div className="feature-icon">
              <BathIcon />
            </div>
            <span className="feature-text">{property.bathrooms} baño</span>
          </div>
          
          <div className="feature-item">
            <div className="feature-icon">
              <AreaIcon />
            </div>
            <span className="feature-text">{property.area}</span>
          </div>
        </div>
        
        <p className="property-description">{property.description}</p>
        <Link to={`/properties/${property.id}`} className="view-details">
          Ver Detalles
        </Link>
      </div>
    </div>
  );
};

export default PropertyCard;